import React from "react";
import { Link } from "react-router-dom";
import { Phone, ClipboardText } from "@phosphor-icons/react";

/**
 * Desktop-only sticky "Request a Quote" button anchored to the right side.
 * Complements the mobile action bar. Hidden on the quote form page itself.
 */
export default function StickyQuoteButton({ pathname = "" }) {
  if (pathname.startsWith("/request-a-quote") || pathname.startsWith("/thank-you") || pathname.startsWith("/admin") || pathname.startsWith("/login")) {
    return null;
  }
  return (
    <div
      data-testid="sticky-quote-btn"
      className="hidden lg:flex fixed right-6 bottom-8 z-40 flex-col gap-2 items-end"
    >
      <a
        href="tel:7029290390"
        data-testid="sticky-call-btn"
        className="flex items-center gap-2 bg-obsidian border border-chrome hover:border-solar text-white px-4 py-2.5 shadow-2xl shadow-black/50 transition-colors"
      >
        <Phone size={16} weight="fill" className="text-solar" />
        <span className="text-xs uppercase tracking-widest font-bold">702-929-0390</span>
      </a>
      <Link
        to="/request-a-quote"
        className="flex items-center gap-2 bg-solar text-black px-4 py-3 shadow-2xl shadow-solar/30 hover:bg-solar-400 transition-colors"
      >
        <ClipboardText size={18} weight="fill" />
        <span className="text-sm uppercase tracking-widest font-bold">Request Assessment</span>
      </Link>
    </div>
  );
}
